<template>
    <c-modal :value="true" size="md" title="What would you like to reset?" @closed="closeModal">
        <c-radio v-model="resetWholePreview" :input-value="false" bordered class="mb-2">
            <div class="radio-content">
                <span class="title">Design Elements Only</span>
                Resets design elements from Step 1 while maintaining your background and layers added for your Preview.
            </div>
        </c-radio>
        <c-radio v-model="resetWholePreview" :input-value="true" bordered>
            <div class="radio-content">
                <span class="title">Whole Preview</span>
                Resets the entire preview to adjust height, width, background and layers added. Elements that belong
                only to your preview will be removed.
            </div>
        </c-radio>
        <template #modal-footer>
            <div class="d-flex justify-content-between w-100">
                <c-button text="Cancel" variant="secondary" @click="closeModal" />
                <c-button text="Reset" variant="primary" @click="onConfirmHandler" />
            </div>
        </template>
    </c-modal>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import CModal from '@/components/CModal.vue';
import CRadio from '@/components/shared/CRadio.vue';
import CButton from '@/components/shared/CButton';
import { DatadogEvent, fireDatadogLog } from '@/utils/datadogUtils';

const emit = defineEmits<{
    (event: 'reset', value: boolean): void;
    (event: 'close'): void;
}>();

const closeModal = () => emit('close');

const resetWholePreview = ref(false);
const onConfirmHandler = () => {
    const action = resetWholePreview.value ? DatadogEvent.ResetPreview : DatadogEvent.ResetPreviewElements;
    fireDatadogLog(action);
    emit('reset', resetWholePreview.value);
};
</script>

<style scoped lang="scss">
.radio-content {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    font-size: 0.75rem;
    .title {
        font-weight: bold;
        font-size: 0.875rem;
    }
}
</style>
